import { useState } from "react";
import axios from "axios";

import Footer from "../home/footer";
import Header from "../home/header";
import Subscribe from "../home/subscribe";
import img from "../../assets/home/makhanacart.png";

const Contact = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    occasion: "",
    message: ""
  });

  const [msg, setMsg]= useState('')

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://eatful.in/email/mainemail.php", 
        form,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.success) {
        setMsg("Message sent successfully ✅");

        setTimeout(() => {
        setMsg(""); // ✅ correct way
        setForm({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            occasion: "",
            message: ""
        });
        }, 2000);


        
      } else {
        alert("Failed to send message ❌");
      }
    } catch (err) {
      console.error(err);
      alert("Server error ❌");
    }
  };

  return (
    <>
      <Header />

      <div className="container-fluid p-0" style={{ background: "black" }}>
         <div className="container-fluid p-0">
            <div style={{
                height:'30vh',
                background:'black',
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
            }}>
                <div className="slider-wrapper"  style={{
                    background:'#FFDA01',
                    textTransform: "upperCase"
                }}>
                    <div className="slider-text">
                    Our delighted product Our delighted product Our delighted product Our delighted product Our delighted product Our delighted product 
                    </div>
                    <div className="slider-text">
                    Our delighted product Our delighted product Our delighted product Our delighted product Our delighted product
                    </div>
                </div>
            </div>
            
        </div>

        <div className="container pb-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img src={img} className="img-fluid" alt="contact" />
            </div>

            <div className="col-md-6">
              <form
                onSubmit={handleSubmit}
                className="p-3 rounded"
                style={{ boxShadow: "6px 6px gray", background: "white" }}
              >
                <h1 className="text-center fw-bold">Contact Here</h1>

                <div className="row">
                  <div className="col-md-6 pt-3">
                    <label>First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      value={form.firstName}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-6 pt-3">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={form.lastName}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-6 pt-3">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-6 pt-3">
                    <label>Contact</label>
                    <input
                      type="text"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-md-12 pt-3">
                    <label>Occasion</label>
                    <select
                      name="occasion"
                      value={form.occasion}
                      onChange={handleChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select</option>
                      <option value="Corporate">Corporate</option>
                      <option value="PR / Influencer">PR / Influencer</option>
                      <option value="Festive">Festive</option>
                    </select>
                  </div>

                  <div className="col-md-12 pt-3">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      className="form-control"
                      rows="4"
                      required
                    />
                  </div>

                  <p>{msg}</p>

                  <div className="col-md-12 pt-3">
                    <button
                      type="submit"
                      className="btn w-100"
                      style={{ background: "black", color: "white" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <Subscribe /> */}
      <Footer />
    </>
  );
};

export default Contact;
